// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type OrderLinesCountState = Readonly<{
    linesCount: number;
}>;

const initialState: OrderLinesCountState = {
    linesCount: 0,
};
const reducer = {
    "xOrderLinesCount/SetCount": (draft: Draft<OrderLinesCountState>, action: { linesCount: number }) => {
        draft.linesCount = action.linesCount;
    },
};

const xOrderLinesCount = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xOrderLinesCount = xOrderLinesCount;

export type xOrderLinesCountState = {
    xOrderLinesCount: OrderLinesCountState;
} & ApplicationState;

type ProductFilterTextReducers = {
    query: typeof xOrderLinesCount;
};

export type xOrderLinesCount = Parameters<ProductFilterTextReducers[keyof ProductFilterTextReducers]>[1] | AnyAction;
